import React, { useState } from 'react'
import Text from '../../../components/text/Text'
import arrowBack from '../../../assets/icons/icons-arrow-back.svg'
import { useNavigate } from 'react-router-dom'
import routes from '../../../router/routes'
import './ProformaCalendar.css'
import Calendar from '../../../components/calendar/Calendar'
import useDate from '../../../hooks/useDate'
import { requestProforma } from '../../../services/billing'
import moment from 'moment'
import { useLoadingContext } from '../../../context/spinnerContext'
import ModalComponent from '../../../components/modal/ModalComponent'

import alert from '../../../assets/icons/icons-error-circle.png'
import check from '../../../assets/icons/icons-success.png'
import error from '../../../assets/icons/icons-error.png'

export default function ProformaCalendarScreen() {
    const [showErrorModal, setShowErrorModal] = useState(false)
    const [proformaMadeModal, setProformaMadeModal] = useState(false)

    const navigate = useNavigate()
    const handleGoBack = () => {
        navigate(`/${routes.billing}`)
    }
    const { handleDate, selectedDate } = useDate(new Date())
    const loadingContext = useLoadingContext()

    const renderErrorModal = () => {
        return (
            <ModalComponent
                show={showErrorModal}
                handleClose={() => setShowErrorModal(false)}
                icon={true}
                modalStyle="error-modal-style"
            >
                <div className="modal-container">
                    <img src={error} className="modal-img" />

                    <Text
                        label="Los movimientos no pudieron ser"
                        color={'#000000'}
                    />
                    <Text label="proformados." color={'#000000'} />
                    <Text
                        label="Si el problema persiste, intenta"
                        color={'#000000'}
                    />
                    <Text label="tarde." color={'#000000'} />

                    <button
                        className="modal-button-style"
                        onClick={() => {
                            setShowErrorModal(false)
                        }}
                    >
                        <Text
                            label="Solicitar proforma"
                            fontSize={14}
                            fontWeight={600}
                            fontFamily={'Montserrat'}
                        />
                    </button>
                </div>
            </ModalComponent>
        )
    }
    const renderProformaMadeModal = () => {
        return (
            <ModalComponent
                show={proformaMadeModal}
                handleClose={() => setProformaMadeModal(false)}
                icon={true}
                modalStyle="success-modal-style"
            >
                <div className="modal-container">
                    <img src={check} className="modal-img" />

                    <Text
                        label="Movimientos proformados con éxito"
                        color={'#000000'}
                    />

                    <button
                        className="modal-button-style"
                        onClick={() => {
                            setProformaMadeModal(false)
                            navigate(`/${routes.billing}/${routes.billingMain}`)
                        }}
                    >
                        <Text
                            label="Ir a histórico de facturación"
                            fontSize={14}
                            fontWeight={600}
                            fontFamily={'Montserrat'}
                        />
                    </button>
                </div>
            </ModalComponent>
        )
    }

    const handleProformaRequest = () => {
        loadingContext?.onOpen()
        requestProforma(
            moment(selectedDate)
                .set({
                    hour: 23,
                    minute: 59,
                    second: 59,
                })
                .format('YYYY-MM-DD')
        )
            .then((response) => {
                if (response.body.data === 'false') {
                    setShowErrorModal(true)
                } else {
                    setProformaMadeModal(true)
                }
            })
            .catch(() => {
                setShowErrorModal(true)
            })
            .finally(() => {
                loadingContext?.onClose()
            })
    }

    const minDate = moment().subtract(1, 'month').startOf('month').toDate()
    const maxDate = moment().toDate()

    return (
        <div className="proforma-screen-container calendar-proforma">
            <div className="proforma-title-container">
                <div className="flex-direction-row">
                    <div>
                        <img
                            src={arrowBack}
                            className="iconContainer-sch"
                            onClick={handleGoBack}
                        />
                    </div>
                    <div>
                        <Text
                            label="Solicitud de proforma"
                            fontSize={20}
                            fontWeight={600}
                            color={'#656565'}
                        />
                    </div>
                </div>
            </div>
            <div className="title-container">
                <div className="flex-direction-row">
                    <img src={alert} className="alert-circle-img" />
                    <Text
                        label="Seleccionar la fecha tope de movimientos para la nueva proforma."
                        fontSize={14}
                        fontWeight={600}
                        color={'#000000'}
                    />
                </div>
            </div>

            <Calendar
                onChange={handleDate}
                minDate={minDate}
                maxDate={maxDate}
            />

            <div className={'centered'}>
                <button
                    className={'button-style'}
                    onClick={handleProformaRequest}
                >
                    <Text
                        label="Solicitar proforma"
                        fontSize={14}
                        fontWeight={600}
                        fontFamily={'Montserrat'}
                    />
                </button>
            </div>
            {renderErrorModal()}
            {renderProformaMadeModal()}
        </div>
    )
}
